module.exports = __webpack_public_path__ + "statics/img/7.fd95dd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/technological/7.png
// module id = Q1Vb
// module chunks = 1